import React from "react"

import Event from "../../../../model2/event/event"

// @ts-ignore
import EventIcon from '../../../icons/event/event-icon'

type Props = {
    event               : Event

    isHighlighted       : boolean
    showParentProject   : boolean
    selected            : boolean

    onClickEvent?       : func
}

const debug = false
// const debug = "FinderEvent"

export default class FinderEvent extends React.Component<Props> {

    click = () => {
        return this.onClickEvent(this.props.event)
    }

    onClickEvent = (event: Event, e?: any) => {
        if (e) { e.stopPropagation() }
        if (this.props.onClickEvent) {
            return this.props.onClickEvent(event)
        }
    }

    render() {
        const classes = Classes("search-item event flex-row-left-center", {
            'is-highlighted': this.props.isHighlighted,
            selected        : this.props.selected
        })

        this.props.event.initFromSession()

        debug && console.log(debug, 'render', this.props.event)

        return (
            <div key       = {this.props.event.id}
                 className = {classes}
                 onClick   = {(e) => this.onClickEvent(this.props.event, e)}>
                <EventIcon
                    className   = "search-item-icon event-ico"
                    event       = {this.props.event}
                />
                <div className="search-item-title flex-1 flex-row-left-center">
                    <div className="search-item-title-label">{this.props.event.name}</div>
                    {this.props.showParentProject &&
                        <div className="search-item-project">
                            <div className="project-label">{this.props.event.project.name}</div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}
